import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingCropSeedingsByPrimaryDataId, setFootprintingCropSeedingsByPrimaryDataIdAdmin } from "services";

import { footprintingCropPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_CROP_SEEDINGS } from "consts";

import { FootprintingCropSeeding } from "models";

export const useMutateFootprintingCropSeedings = (farmId: string, cropId: string, year: number, payload: FootprintingCropSeeding[], primaryDataId: string) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? setFootprintingCropSeedingsByPrimaryDataIdAdmin : setFootprintingCropSeedingsByPrimaryDataId;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_CROP_SEEDINGS, primaryDataId, isAdmin],
      mutationFn: () => queryFn(payload, primaryDataId ?? ""),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_CROP_SEEDINGS, primaryDataId, isAdmin],
          ...footprintingCropPrimaryQueryKeys(primaryDataId, farmId, cropId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
